'use client';

import { SessionProvider } from 'next-auth/react';
import StepsHeader from './StepsHeader';

import './StepsHeader.scss';
import { Session } from 'next-auth';

interface StepsHeaderWrapperProps {
  session?: Session | null;
}

const StepsHeaderWrapper = ({ session = null }: StepsHeaderWrapperProps) => {
  return (
    <SessionProvider session={session}>
      <StepsHeader />
    </SessionProvider>
  );
};

export default StepsHeaderWrapper;
